/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import {
  AirspaceVolume_Enum,
  airspaceVolume_EnumFromJSON,
  airspaceVolume_EnumToJSON,
} from "../../gen/adsb_regulatory_manager/airspace_volume";
import { VolumeDimensions } from "../../gen/adsb_regulatory_manager/volume_dimensions";

export const protobufPackage = "adsb_regulatory_manager";

export interface AdsbRespondAction {
}

export enum AdsbRespondAction_Enum {
  /** NONE - No action */
  NONE = 0,
  /** DESCEND - Descend to compliant altitude. */
  DESCEND = 1,
  /** LAND - Smart land. */
  LAND = 2,
  UNRECOGNIZED = -1,
}

export function adsbRespondAction_EnumFromJSON(object: any): AdsbRespondAction_Enum {
  switch (object) {
    case 0:
    case "NONE":
      return AdsbRespondAction_Enum.NONE;
    case 1:
    case "DESCEND":
      return AdsbRespondAction_Enum.DESCEND;
    case 2:
    case "LAND":
      return AdsbRespondAction_Enum.LAND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AdsbRespondAction_Enum.UNRECOGNIZED;
  }
}

export function adsbRespondAction_EnumToJSON(object: AdsbRespondAction_Enum): string {
  switch (object) {
    case AdsbRespondAction_Enum.NONE:
      return "NONE";
    case AdsbRespondAction_Enum.DESCEND:
      return "DESCEND";
    case AdsbRespondAction_Enum.LAND:
      return "LAND";
    case AdsbRespondAction_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** State machine states for the ADS-B regulatory manager. */
export interface AdsbRegulatoryManagerState {
}

export enum AdsbRegulatoryManagerState_Enum {
  /** UNKNOWN - Unknown state */
  UNKNOWN = 0,
  /** DISABLED - Auto-response is disabled. */
  DISABLED = 1,
  /** IDLE - No encroaching aircraft detected. */
  IDLE = 2,
  /** RESPONDING - Auto-response in progress. */
  RESPONDING = 3,
  /** WAITING_TO_CLEAR - Response complete, waiting for aircraft to clear. */
  WAITING_TO_CLEAR = 4,
  /** RECOVERING - Aircraft cleared, recovering. */
  RECOVERING = 5,
  /** PILOT_IN_CONTROL - Pilot stopped the response mission; pilot has control. */
  PILOT_IN_CONTROL = 6,
  UNRECOGNIZED = -1,
}

export function adsbRegulatoryManagerState_EnumFromJSON(object: any): AdsbRegulatoryManagerState_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return AdsbRegulatoryManagerState_Enum.UNKNOWN;
    case 1:
    case "DISABLED":
      return AdsbRegulatoryManagerState_Enum.DISABLED;
    case 2:
    case "IDLE":
      return AdsbRegulatoryManagerState_Enum.IDLE;
    case 3:
    case "RESPONDING":
      return AdsbRegulatoryManagerState_Enum.RESPONDING;
    case 4:
    case "WAITING_TO_CLEAR":
      return AdsbRegulatoryManagerState_Enum.WAITING_TO_CLEAR;
    case 5:
    case "RECOVERING":
      return AdsbRegulatoryManagerState_Enum.RECOVERING;
    case 6:
    case "PILOT_IN_CONTROL":
      return AdsbRegulatoryManagerState_Enum.PILOT_IN_CONTROL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AdsbRegulatoryManagerState_Enum.UNRECOGNIZED;
  }
}

export function adsbRegulatoryManagerState_EnumToJSON(object: AdsbRegulatoryManagerState_Enum): string {
  switch (object) {
    case AdsbRegulatoryManagerState_Enum.UNKNOWN:
      return "UNKNOWN";
    case AdsbRegulatoryManagerState_Enum.DISABLED:
      return "DISABLED";
    case AdsbRegulatoryManagerState_Enum.IDLE:
      return "IDLE";
    case AdsbRegulatoryManagerState_Enum.RESPONDING:
      return "RESPONDING";
    case AdsbRegulatoryManagerState_Enum.WAITING_TO_CLEAR:
      return "WAITING_TO_CLEAR";
    case AdsbRegulatoryManagerState_Enum.RECOVERING:
      return "RECOVERING";
    case AdsbRegulatoryManagerState_Enum.PILOT_IN_CONTROL:
      return "PILOT_IN_CONTROL";
    case AdsbRegulatoryManagerState_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Operating mode for the ADS-B regulatory manager. */
export interface AdsbRegulatoryManagerMode {
}

export enum AdsbRegulatoryManagerMode_Enum {
  /** OFF - ADS-B regulatory manager is disabled. */
  OFF = 0,
  /** ON - Full auto-response enabled. */
  ON = 1,
  /** INFO - Info-only mode; alert pilot but do not auto-respond. */
  INFO = 2,
  UNRECOGNIZED = -1,
}

export function adsbRegulatoryManagerMode_EnumFromJSON(object: any): AdsbRegulatoryManagerMode_Enum {
  switch (object) {
    case 0:
    case "OFF":
      return AdsbRegulatoryManagerMode_Enum.OFF;
    case 1:
    case "ON":
      return AdsbRegulatoryManagerMode_Enum.ON;
    case 2:
    case "INFO":
      return AdsbRegulatoryManagerMode_Enum.INFO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AdsbRegulatoryManagerMode_Enum.UNRECOGNIZED;
  }
}

export function adsbRegulatoryManagerMode_EnumToJSON(object: AdsbRegulatoryManagerMode_Enum): string {
  switch (object) {
    case AdsbRegulatoryManagerMode_Enum.OFF:
      return "OFF";
    case AdsbRegulatoryManagerMode_Enum.ON:
      return "ON";
    case AdsbRegulatoryManagerMode_Enum.INFO:
      return "INFO";
    case AdsbRegulatoryManagerMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Describes how an aircraft intersects a volume. */
export interface AirspaceVolumeState {
}

export enum AirspaceVolumeState_Enum {
  NONE = 0,
  /** INSIDE - Aircraft is inside the volume */
  INSIDE = 1,
  /** INTERSECTING - Aircraft is intersecting the volume */
  INTERSECTING = 2,
  UNRECOGNIZED = -1,
}

export function airspaceVolumeState_EnumFromJSON(object: any): AirspaceVolumeState_Enum {
  switch (object) {
    case 0:
    case "NONE":
      return AirspaceVolumeState_Enum.NONE;
    case 1:
    case "INSIDE":
      return AirspaceVolumeState_Enum.INSIDE;
    case 2:
    case "INTERSECTING":
      return AirspaceVolumeState_Enum.INTERSECTING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AirspaceVolumeState_Enum.UNRECOGNIZED;
  }
}

export function airspaceVolumeState_EnumToJSON(object: AirspaceVolumeState_Enum): string {
  switch (object) {
    case AirspaceVolumeState_Enum.NONE:
      return "NONE";
    case AirspaceVolumeState_Enum.INSIDE:
      return "INSIDE";
    case AirspaceVolumeState_Enum.INTERSECTING:
      return "INTERSECTING";
    case AirspaceVolumeState_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Describes FAA compliance state for the vehicle. */
export interface EncroachmentState {
  /** How the aircraft intersects the volume */
  state?:
    | AirspaceVolumeState_Enum
    | undefined;
  /** Which volume the aircraft is encroaching */
  volume?: AirspaceVolume_Enum | undefined;
}

/** Vehicle compliance state relative to an encroaching aircraft. */
export interface VehicleComplianceState {
}

export enum VehicleComplianceState_Enum {
  /** UNKNOWN - Compliance not yet determined. */
  UNKNOWN = 0,
  /** COMPLIANT - Aircraft outside the safe distance (SD) cylinder. */
  COMPLIANT = 1,
  /** NON_COMPLIANT_SD - Aircraft inside SD but outside NMAC. */
  NON_COMPLIANT_SD = 2,
  /** NON_COMPLIANT_NMAC - Aircraft inside NMAC cylinder. */
  NON_COMPLIANT_NMAC = 3,
  UNRECOGNIZED = -1,
}

export function vehicleComplianceState_EnumFromJSON(object: any): VehicleComplianceState_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return VehicleComplianceState_Enum.UNKNOWN;
    case 1:
    case "COMPLIANT":
      return VehicleComplianceState_Enum.COMPLIANT;
    case 2:
    case "NON_COMPLIANT_SD":
      return VehicleComplianceState_Enum.NON_COMPLIANT_SD;
    case 3:
    case "NON_COMPLIANT_NMAC":
      return VehicleComplianceState_Enum.NON_COMPLIANT_NMAC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VehicleComplianceState_Enum.UNRECOGNIZED;
  }
}

export function vehicleComplianceState_EnumToJSON(object: VehicleComplianceState_Enum): string {
  switch (object) {
    case VehicleComplianceState_Enum.UNKNOWN:
      return "UNKNOWN";
    case VehicleComplianceState_Enum.COMPLIANT:
      return "COMPLIANT";
    case VehicleComplianceState_Enum.NON_COMPLIANT_SD:
      return "NON_COMPLIANT_SD";
    case VehicleComplianceState_Enum.NON_COMPLIANT_NMAC:
      return "NON_COMPLIANT_NMAC";
    case VehicleComplianceState_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Published status of the ADS-B regulatory manager. */
export interface AdsbRegulatoryManagerStatus {
  /** Timestamp in microseconds. */
  utime: number;
  /** Operating mode. */
  mode: AdsbRegulatoryManagerMode_Enum;
  /** Current state machine state. */
  state: AdsbRegulatoryManagerState_Enum;
  /** Current compliance state. */
  complianceState: VehicleComplianceState_Enum;
  /** Action used for response */
  currentRespondAction?:
    | AdsbRespondAction_Enum
    | undefined;
  /** Encroachment at current pose. */
  currentPoseEncroachmentState?: EncroachmentState | undefined;
}

/** Minimal published status of the ADS-B regulatory manager. */
export interface AdsbRegulatoryManagerMinimalStatus {
  /** Timestamp in microseconds. */
  utime: number;
  /** Operating mode. */
  mode: AdsbRegulatoryManagerMode_Enum;
  /** Current state machine state. */
  state: AdsbRegulatoryManagerState_Enum;
  /** Action used for response */
  currentRespondAction?: AdsbRespondAction_Enum | undefined;
}

/** Runtime settings for the ADS-B regulatory manager. */
export interface AdsbRegulatoryManagerSettings {
  /** Operating mode. */
  mode: AdsbRegulatoryManagerMode_Enum;
  /** Filter volume dimensions. */
  filterDimensions:
    | VolumeDimensions
    | undefined;
  /** Alert volume dimensions. */
  alertDimensions:
    | VolumeDimensions
    | undefined;
  /** SD buffer volume dimensions. */
  sdBufferDimensions:
    | VolumeDimensions
    | undefined;
  /** SD volume dimensions. */
  sdDimensions:
    | VolumeDimensions
    | undefined;
  /** NMAC buffer volume dimensions. */
  nmacBufferDimensions:
    | VolumeDimensions
    | undefined;
  /** NMAC volume dimensions. */
  nmacDimensions:
    | VolumeDimensions
    | undefined;
  /** AGL compliance altitude in meters. */
  aglComplianceAltitude: number;
}

function createBaseAdsbRespondAction(): AdsbRespondAction {
  return {};
}

export const AdsbRespondAction = {
  encode(_: AdsbRespondAction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdsbRespondAction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdsbRespondAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AdsbRespondAction {
    return {};
  },

  toJSON(_: AdsbRespondAction): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AdsbRespondAction>, I>>(base?: I): AdsbRespondAction {
    return AdsbRespondAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdsbRespondAction>, I>>(_: I): AdsbRespondAction {
    const message = createBaseAdsbRespondAction();
    return message;
  },
};

function createBaseAdsbRegulatoryManagerState(): AdsbRegulatoryManagerState {
  return {};
}

export const AdsbRegulatoryManagerState = {
  encode(_: AdsbRegulatoryManagerState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdsbRegulatoryManagerState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdsbRegulatoryManagerState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AdsbRegulatoryManagerState {
    return {};
  },

  toJSON(_: AdsbRegulatoryManagerState): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AdsbRegulatoryManagerState>, I>>(base?: I): AdsbRegulatoryManagerState {
    return AdsbRegulatoryManagerState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdsbRegulatoryManagerState>, I>>(_: I): AdsbRegulatoryManagerState {
    const message = createBaseAdsbRegulatoryManagerState();
    return message;
  },
};

function createBaseAdsbRegulatoryManagerMode(): AdsbRegulatoryManagerMode {
  return {};
}

export const AdsbRegulatoryManagerMode = {
  encode(_: AdsbRegulatoryManagerMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdsbRegulatoryManagerMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdsbRegulatoryManagerMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AdsbRegulatoryManagerMode {
    return {};
  },

  toJSON(_: AdsbRegulatoryManagerMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AdsbRegulatoryManagerMode>, I>>(base?: I): AdsbRegulatoryManagerMode {
    return AdsbRegulatoryManagerMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdsbRegulatoryManagerMode>, I>>(_: I): AdsbRegulatoryManagerMode {
    const message = createBaseAdsbRegulatoryManagerMode();
    return message;
  },
};

function createBaseAirspaceVolumeState(): AirspaceVolumeState {
  return {};
}

export const AirspaceVolumeState = {
  encode(_: AirspaceVolumeState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AirspaceVolumeState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAirspaceVolumeState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AirspaceVolumeState {
    return {};
  },

  toJSON(_: AirspaceVolumeState): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AirspaceVolumeState>, I>>(base?: I): AirspaceVolumeState {
    return AirspaceVolumeState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AirspaceVolumeState>, I>>(_: I): AirspaceVolumeState {
    const message = createBaseAirspaceVolumeState();
    return message;
  },
};

function createBaseEncroachmentState(): EncroachmentState {
  return { state: undefined, volume: undefined };
}

export const EncroachmentState = {
  encode(message: EncroachmentState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.state !== undefined) {
      writer.uint32(8).int32(message.state);
    }
    if (message.volume !== undefined) {
      writer.uint32(16).int32(message.volume);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EncroachmentState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEncroachmentState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.volume = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EncroachmentState {
    return {
      state: isSet(object.state) ? airspaceVolumeState_EnumFromJSON(object.state) : undefined,
      volume: isSet(object.volume) ? airspaceVolume_EnumFromJSON(object.volume) : undefined,
    };
  },

  toJSON(message: EncroachmentState): unknown {
    const obj: any = {};
    if (message.state !== undefined) {
      obj.state = airspaceVolumeState_EnumToJSON(message.state);
    }
    if (message.volume !== undefined) {
      obj.volume = airspaceVolume_EnumToJSON(message.volume);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EncroachmentState>, I>>(base?: I): EncroachmentState {
    return EncroachmentState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EncroachmentState>, I>>(object: I): EncroachmentState {
    const message = createBaseEncroachmentState();
    message.state = object.state ?? undefined;
    message.volume = object.volume ?? undefined;
    return message;
  },
};

function createBaseVehicleComplianceState(): VehicleComplianceState {
  return {};
}

export const VehicleComplianceState = {
  encode(_: VehicleComplianceState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VehicleComplianceState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVehicleComplianceState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): VehicleComplianceState {
    return {};
  },

  toJSON(_: VehicleComplianceState): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<VehicleComplianceState>, I>>(base?: I): VehicleComplianceState {
    return VehicleComplianceState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VehicleComplianceState>, I>>(_: I): VehicleComplianceState {
    const message = createBaseVehicleComplianceState();
    return message;
  },
};

function createBaseAdsbRegulatoryManagerStatus(): AdsbRegulatoryManagerStatus {
  return {
    utime: 0,
    mode: 0,
    state: 0,
    complianceState: 0,
    currentRespondAction: undefined,
    currentPoseEncroachmentState: undefined,
  };
}

export const AdsbRegulatoryManagerStatus = {
  encode(message: AdsbRegulatoryManagerStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }
    if (message.state !== 0) {
      writer.uint32(24).int32(message.state);
    }
    if (message.complianceState !== 0) {
      writer.uint32(32).int32(message.complianceState);
    }
    if (message.currentRespondAction !== undefined) {
      writer.uint32(48).int32(message.currentRespondAction);
    }
    if (message.currentPoseEncroachmentState !== undefined) {
      EncroachmentState.encode(message.currentPoseEncroachmentState, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdsbRegulatoryManagerStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdsbRegulatoryManagerStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.complianceState = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.currentRespondAction = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.currentPoseEncroachmentState = EncroachmentState.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdsbRegulatoryManagerStatus {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      mode: isSet(object.mode) ? adsbRegulatoryManagerMode_EnumFromJSON(object.mode) : 0,
      state: isSet(object.state) ? adsbRegulatoryManagerState_EnumFromJSON(object.state) : 0,
      complianceState: isSet(object.complianceState) ? vehicleComplianceState_EnumFromJSON(object.complianceState) : 0,
      currentRespondAction: isSet(object.currentRespondAction)
        ? adsbRespondAction_EnumFromJSON(object.currentRespondAction)
        : undefined,
      currentPoseEncroachmentState: isSet(object.currentPoseEncroachmentState)
        ? EncroachmentState.fromJSON(object.currentPoseEncroachmentState)
        : undefined,
    };
  },

  toJSON(message: AdsbRegulatoryManagerStatus): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.mode !== 0) {
      obj.mode = adsbRegulatoryManagerMode_EnumToJSON(message.mode);
    }
    if (message.state !== 0) {
      obj.state = adsbRegulatoryManagerState_EnumToJSON(message.state);
    }
    if (message.complianceState !== 0) {
      obj.complianceState = vehicleComplianceState_EnumToJSON(message.complianceState);
    }
    if (message.currentRespondAction !== undefined) {
      obj.currentRespondAction = adsbRespondAction_EnumToJSON(message.currentRespondAction);
    }
    if (message.currentPoseEncroachmentState !== undefined) {
      obj.currentPoseEncroachmentState = EncroachmentState.toJSON(message.currentPoseEncroachmentState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdsbRegulatoryManagerStatus>, I>>(base?: I): AdsbRegulatoryManagerStatus {
    return AdsbRegulatoryManagerStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdsbRegulatoryManagerStatus>, I>>(object: I): AdsbRegulatoryManagerStatus {
    const message = createBaseAdsbRegulatoryManagerStatus();
    message.utime = object.utime ?? 0;
    message.mode = object.mode ?? 0;
    message.state = object.state ?? 0;
    message.complianceState = object.complianceState ?? 0;
    message.currentRespondAction = object.currentRespondAction ?? undefined;
    message.currentPoseEncroachmentState =
      (object.currentPoseEncroachmentState !== undefined && object.currentPoseEncroachmentState !== null)
        ? EncroachmentState.fromPartial(object.currentPoseEncroachmentState)
        : undefined;
    return message;
  },
};

function createBaseAdsbRegulatoryManagerMinimalStatus(): AdsbRegulatoryManagerMinimalStatus {
  return { utime: 0, mode: 0, state: 0, currentRespondAction: undefined };
}

export const AdsbRegulatoryManagerMinimalStatus = {
  encode(message: AdsbRegulatoryManagerMinimalStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }
    if (message.state !== 0) {
      writer.uint32(24).int32(message.state);
    }
    if (message.currentRespondAction !== undefined) {
      writer.uint32(48).int32(message.currentRespondAction);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdsbRegulatoryManagerMinimalStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdsbRegulatoryManagerMinimalStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.currentRespondAction = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdsbRegulatoryManagerMinimalStatus {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      mode: isSet(object.mode) ? adsbRegulatoryManagerMode_EnumFromJSON(object.mode) : 0,
      state: isSet(object.state) ? adsbRegulatoryManagerState_EnumFromJSON(object.state) : 0,
      currentRespondAction: isSet(object.currentRespondAction)
        ? adsbRespondAction_EnumFromJSON(object.currentRespondAction)
        : undefined,
    };
  },

  toJSON(message: AdsbRegulatoryManagerMinimalStatus): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.mode !== 0) {
      obj.mode = adsbRegulatoryManagerMode_EnumToJSON(message.mode);
    }
    if (message.state !== 0) {
      obj.state = adsbRegulatoryManagerState_EnumToJSON(message.state);
    }
    if (message.currentRespondAction !== undefined) {
      obj.currentRespondAction = adsbRespondAction_EnumToJSON(message.currentRespondAction);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdsbRegulatoryManagerMinimalStatus>, I>>(
    base?: I,
  ): AdsbRegulatoryManagerMinimalStatus {
    return AdsbRegulatoryManagerMinimalStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdsbRegulatoryManagerMinimalStatus>, I>>(
    object: I,
  ): AdsbRegulatoryManagerMinimalStatus {
    const message = createBaseAdsbRegulatoryManagerMinimalStatus();
    message.utime = object.utime ?? 0;
    message.mode = object.mode ?? 0;
    message.state = object.state ?? 0;
    message.currentRespondAction = object.currentRespondAction ?? undefined;
    return message;
  },
};

function createBaseAdsbRegulatoryManagerSettings(): AdsbRegulatoryManagerSettings {
  return {
    mode: 0,
    filterDimensions: undefined,
    alertDimensions: undefined,
    sdBufferDimensions: undefined,
    sdDimensions: undefined,
    nmacBufferDimensions: undefined,
    nmacDimensions: undefined,
    aglComplianceAltitude: 0,
  };
}

export const AdsbRegulatoryManagerSettings = {
  encode(message: AdsbRegulatoryManagerSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode);
    }
    if (message.filterDimensions !== undefined) {
      VolumeDimensions.encode(message.filterDimensions, writer.uint32(18).fork()).ldelim();
    }
    if (message.alertDimensions !== undefined) {
      VolumeDimensions.encode(message.alertDimensions, writer.uint32(26).fork()).ldelim();
    }
    if (message.sdBufferDimensions !== undefined) {
      VolumeDimensions.encode(message.sdBufferDimensions, writer.uint32(34).fork()).ldelim();
    }
    if (message.sdDimensions !== undefined) {
      VolumeDimensions.encode(message.sdDimensions, writer.uint32(42).fork()).ldelim();
    }
    if (message.nmacBufferDimensions !== undefined) {
      VolumeDimensions.encode(message.nmacBufferDimensions, writer.uint32(50).fork()).ldelim();
    }
    if (message.nmacDimensions !== undefined) {
      VolumeDimensions.encode(message.nmacDimensions, writer.uint32(58).fork()).ldelim();
    }
    if (message.aglComplianceAltitude !== 0) {
      writer.uint32(69).float(message.aglComplianceAltitude);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AdsbRegulatoryManagerSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdsbRegulatoryManagerSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.filterDimensions = VolumeDimensions.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.alertDimensions = VolumeDimensions.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.sdBufferDimensions = VolumeDimensions.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.sdDimensions = VolumeDimensions.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.nmacBufferDimensions = VolumeDimensions.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.nmacDimensions = VolumeDimensions.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.aglComplianceAltitude = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdsbRegulatoryManagerSettings {
    return {
      mode: isSet(object.mode) ? adsbRegulatoryManagerMode_EnumFromJSON(object.mode) : 0,
      filterDimensions: isSet(object.filterDimensions) ? VolumeDimensions.fromJSON(object.filterDimensions) : undefined,
      alertDimensions: isSet(object.alertDimensions) ? VolumeDimensions.fromJSON(object.alertDimensions) : undefined,
      sdBufferDimensions: isSet(object.sdBufferDimensions)
        ? VolumeDimensions.fromJSON(object.sdBufferDimensions)
        : undefined,
      sdDimensions: isSet(object.sdDimensions) ? VolumeDimensions.fromJSON(object.sdDimensions) : undefined,
      nmacBufferDimensions: isSet(object.nmacBufferDimensions)
        ? VolumeDimensions.fromJSON(object.nmacBufferDimensions)
        : undefined,
      nmacDimensions: isSet(object.nmacDimensions) ? VolumeDimensions.fromJSON(object.nmacDimensions) : undefined,
      aglComplianceAltitude: isSet(object.aglComplianceAltitude) ? globalThis.Number(object.aglComplianceAltitude) : 0,
    };
  },

  toJSON(message: AdsbRegulatoryManagerSettings): unknown {
    const obj: any = {};
    if (message.mode !== 0) {
      obj.mode = adsbRegulatoryManagerMode_EnumToJSON(message.mode);
    }
    if (message.filterDimensions !== undefined) {
      obj.filterDimensions = VolumeDimensions.toJSON(message.filterDimensions);
    }
    if (message.alertDimensions !== undefined) {
      obj.alertDimensions = VolumeDimensions.toJSON(message.alertDimensions);
    }
    if (message.sdBufferDimensions !== undefined) {
      obj.sdBufferDimensions = VolumeDimensions.toJSON(message.sdBufferDimensions);
    }
    if (message.sdDimensions !== undefined) {
      obj.sdDimensions = VolumeDimensions.toJSON(message.sdDimensions);
    }
    if (message.nmacBufferDimensions !== undefined) {
      obj.nmacBufferDimensions = VolumeDimensions.toJSON(message.nmacBufferDimensions);
    }
    if (message.nmacDimensions !== undefined) {
      obj.nmacDimensions = VolumeDimensions.toJSON(message.nmacDimensions);
    }
    if (message.aglComplianceAltitude !== 0) {
      obj.aglComplianceAltitude = message.aglComplianceAltitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdsbRegulatoryManagerSettings>, I>>(base?: I): AdsbRegulatoryManagerSettings {
    return AdsbRegulatoryManagerSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdsbRegulatoryManagerSettings>, I>>(
    object: I,
  ): AdsbRegulatoryManagerSettings {
    const message = createBaseAdsbRegulatoryManagerSettings();
    message.mode = object.mode ?? 0;
    message.filterDimensions = (object.filterDimensions !== undefined && object.filterDimensions !== null)
      ? VolumeDimensions.fromPartial(object.filterDimensions)
      : undefined;
    message.alertDimensions = (object.alertDimensions !== undefined && object.alertDimensions !== null)
      ? VolumeDimensions.fromPartial(object.alertDimensions)
      : undefined;
    message.sdBufferDimensions = (object.sdBufferDimensions !== undefined && object.sdBufferDimensions !== null)
      ? VolumeDimensions.fromPartial(object.sdBufferDimensions)
      : undefined;
    message.sdDimensions = (object.sdDimensions !== undefined && object.sdDimensions !== null)
      ? VolumeDimensions.fromPartial(object.sdDimensions)
      : undefined;
    message.nmacBufferDimensions = (object.nmacBufferDimensions !== undefined && object.nmacBufferDimensions !== null)
      ? VolumeDimensions.fromPartial(object.nmacBufferDimensions)
      : undefined;
    message.nmacDimensions = (object.nmacDimensions !== undefined && object.nmacDimensions !== null)
      ? VolumeDimensions.fromPartial(object.nmacDimensions)
      : undefined;
    message.aglComplianceAltitude = object.aglComplianceAltitude ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
